import React from 'react';
import { Drawer, Slide } from '@mui/material';
import './CustomDrawer.scss';

export default function CustomDrawer({
  open,
  onClose,
  children,
  title,
  width = 'calc(max(60vw, 300px))',
}) {
  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      sx={{ '& .MuiDrawer-paper': { width: width } }}
      TransitionComponent={Slide}
      classes={{
        paper: 'custom-drawer-paper',
      }}
    >
      {children}
    </Drawer>
  );
}
